import { useEffect, useState } from 'react';

export default function InvoicesTest() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/invoices', { 
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
    .then(res => res.json())
    .then(result => {
      setData(result);
      setLoading(false);
    })
    .catch(err => {
      console.error('Error:', err);
      setLoading(false);
    });
  }, []);

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f8ff', minHeight: '100vh' }}>
      <h1 style={{ color: '#333', fontSize: '24px', marginBottom: '20px' }}>
        🔧 TEST STRÁNKA FAKTÚR
      </h1>
      
      <div style={{ backgroundColor: '#90EE90', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
        <h2>Debug Info:</h2>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        <p><strong>Data exists:</strong> {data ? 'Yes' : 'No'}</p>
        <p><strong>Invoices count:</strong> {data?.data?.length || 0}</p>
      </div>

      {data?.data && data.data.length > 0 && (
        <div style={{ backgroundColor: '#FFFFE0', padding: '15px', borderRadius: '8px' }}>
          <h2>Faktúry:</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid black' }}>
            <thead>
              <tr style={{ backgroundColor: '#ddd' }}>
                <th style={{ border: '1px solid black', padding: '8px' }}>Číslo</th>
                <th style={{ border: '1px solid black', padding: '8px' }}>Status</th>
                <th style={{ border: '1px solid black', padding: '8px' }}>Suma</th>
                <th style={{ border: '1px solid black', padding: '8px' }}>Dátum</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((invoice: any) => (
                <tr key={invoice.id}>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{invoice.invoiceNumber}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{invoice.status}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{invoice.totalAmount}€</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>
                    {new Date(invoice.issueDate).toLocaleDateString('sk-SK')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ marginTop: '20px', backgroundColor: '#FFE4E1', padding: '15px', borderRadius: '8px' }}>
        <h3>Raw API Response:</h3>
        <pre style={{ fontSize: '12px', overflow: 'auto' }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  );
}